// extracted by mini-css-extract-plugin
export default {"main":"RedirectModal_main__ydBJV","info":"RedirectModal_info__7-y2i"};